import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ModalProps from "@ltypes/modalProps";
import Screenshot from "@ltypes/screenshot";
import Modal from "@components/modals/Modal/Modal";
import './ScreenshotModal.scss';
import { useEffect, useState } from "react";
import Badge from "@components/ui/Badge/Badge";
import { sceneTypes } from "../../../constants";
import DateHelper from "@helpers/DateHelper";

type ScreenshotModalProps = {
    screenshot: Screenshot|null,
} & ModalProps;

function ScreenshotModal(props: ScreenshotModalProps) {

    const [screenshotData, setScreenshotData] = useState<any>({});

    // const dispatch = useDispatch();
    // const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if(!props.screenshot) return;
        try {
            setScreenshotData(JSON.parse(props.screenshot.data));
        } catch(e) {
            console.log('Not a valid JSON : %s', props.screenshot.data);
        }
    }, [props.screenshot]);

    return (
        <Modal className="modal-screenshot" visible={props.visible} onHide={props.onHide}>
            {props.screenshot === null ? <></> : (
                <div className="row g-2">
                    <div className="col-12 col-sm-5 col-md-4">
                        <div className="screenshot-item-image" style={{backgroundImage: `url("${process.env.REACT_APP_API_URL}/media/screenshots/${props.screenshot.id}.jpg")`}}></div>
                    </div>
                    <div className="col-12 col-sm-7 col-md-8">
                        <div className="row">
                            <div className="col">
                                <h2>{t(`page.scenes.type.${sceneTypes[props.screenshot.scene_type]}`)}</h2>
                            </div>
                            <div className="col-auto">
                                {DateHelper.formatDate(props.screenshot.created_at, true)}
                            </div>
                        </div>

                        {props.screenshot.scene_type === 0 && Array.isArray(screenshotData) && screenshotData.length > 0 && (
                            <div className="screenshot-crypto-data">
                                {screenshotData.map((coin: any, index: number) => (
                                    <div key={index} className="crypto-item">
                                        <div className="crypto-symbol">
                                            <Badge>{coin.s ?? '$$$'}</Badge>
                                        </div>
                                        <div className="crypto-details">
                                            <div className="crypto-price">
                                                {coin.m === 1 ? '€' : '$'}{coin.v ?? '-.--'}
                                            </div>
                                            <div className={`crypto-change ${coin.c?.charAt(0) === '-' ? 'negative' : 'positive'}`}>
                                                {!coin.c ? '+--' : (coin.c.charAt(0) === '-' ? '' : '+') + coin.c}%
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </Modal>
    );
}

export default ScreenshotModal;
